// extracted by mini-css-extract-plugin
export var bottom = "RegisterForm-module__bottom___bSwpB";
export var center = "RegisterForm-module__center___P26Vu";
export var form = "RegisterForm-module__form___kRy5H";
export var subscribedContainer = "RegisterForm-module__subscribedContainer___JJCkq";